import { Component, OnInit } from '@angular/core';
import { FormGroup,FormBuilder,Validator, Validators } from '@angular/forms';
import { Router,ActivatedRoute } from '@angular/router';
import { LoaderService } from 'src/app/service/loader.service';
import { CookieService } from 'ngx-cookie-service';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-start-meeting',
    templateUrl: './start-meeting.component.html',
    styleUrls: ['./start-meeting.component.scss'],
    standalone: false
})
export class StartMeetingComponent implements OnInit {

  meetingForm !: FormGroup;
  isFormSubmitted:boolean = false;
  cookieValue : any;
  meetingId : any;

  constructor(
    private fb : FormBuilder,
    private router : Router,
    private loader : LoaderService,
    private cookieService : CookieService,
    private route : ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.meetingForm = this.fb.group({
      meetingId:['',Validators.required],
      token:['',Validators.required]
    });

    let cookieTokenExists: boolean = this.cookieService.check('JWTtoken');
    let cookieTokenValue : any;

    let cookieMeetingExists: boolean = this.cookieService.check('meetingID');
    let cookieMeetingValue :any;

    // if(cookieTokenExists && cookieMeetingExists){
      if(cookieTokenExists){
      cookieTokenValue = this.cookieService.get('JWTtoken');
      cookieMeetingValue = this.cookieService.get('meetingID');
      let cookieTokenDecrypted : any= CryptoJS.AES.decrypt(cookieTokenValue,environment.acsEncKey);
      let cookieMeetingIDDecrypted : any= CryptoJS.AES.decrypt(cookieTokenValue,environment.acsEncKey);
  
      
  
      console.log('cookieTokenExists',cookieTokenExists);
      console.log('cookieTokenValue',cookieTokenDecrypted);
  
      console.log('cookieMeetingExists',cookieMeetingExists);
      console.log('cookieMeetingValue',cookieMeetingIDDecrypted);
  
      this.meetingForm.patchValue({
        meetingId: cookieMeetingIDDecrypted,
        token : cookieTokenDecrypted
      });
      localStorage.setItem('ACS-Token',cookieTokenDecrypted);
    }else{
      window.open(environment.afriSureUat, '_blank');
    }
  }

  get a() { return this.meetingForm.controls }

  submitForm(){
    this.isFormSubmitted = true;
    console.log(this.meetingForm.value);
    if(this.meetingForm.invalid){
      return;
    }
    else{
      
      this.router.navigate(['meeting',this.meetingForm.value.meetingId]);
    }
  }

}
